import React, {memo} from 'react';
import {
    SelfChatContainer,
    ChatContainer,
    AvatarContainer,
    Avatar,
    Detail,
    AvatarImage,
    SenderDetail,
    SelfSenderDetail,
    NickName,
    Message,
} from "./chat-content.styles";

const ChatContent = ({isSelf, message, avatarSource, nickName, timestamp}) => {

    if (isSelf) {
        return (
            <SelfChatContainer>
                <p className='mb-0 d-gray-text'>{message}</p>
                <SelfSenderDetail className='d-flex'>
                    <Detail className='me-2'>
                        <p className='mb-2'>{timestamp}</p>
                    </Detail>
                    <div className='position-relative'>
                        <AvatarContainer className='d-flex align-items-center justify-content-center'>
                            <Avatar>
                                <AvatarImage src={avatarSource}/>
                            </Avatar>
                        </AvatarContainer>
                        <NickName className='mb-0 mt-1 content-overflow'>{nickName}</NickName>
                    </div>
                </SelfSenderDetail>
            </SelfChatContainer>
        )
    }
    return (
        <ChatContainer>
            <Message className='mb-0'>{message}</Message>
            <SenderDetail className='d-flex'>
                <div className='position-relative'>
                    <AvatarContainer className='d-flex align-items-center justify-content-center'>
                        <Avatar>
                            <AvatarImage src={avatarSource}/>
                        </Avatar>
                    </AvatarContainer>
                    <NickName className='mb-0 mt-1 content-overflow'>{nickName}</NickName>
                </div>
                <Detail className='ms-2'>
                    <p className='mb-2'>{timestamp}</p>
                </Detail>
            </SenderDetail>
        </ChatContainer>
    );
};

export default memo(ChatContent);
